var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"gameInner",staticClass:"game-inner"},[_c('span',{staticClass:"game-close",on:{"click":_vm.onClose}},[_c('svg-icon',{attrs:{"icon":"close"}})],1),_c('GamePlayer',{ref:"gamePlayer",on:{"onGamePlaySubmit":_vm.onClose}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }